<template>
    <v-card class="add-sponsor custom-dailog">
        <v-card-title v-if="showTitle">
            {{ sponsorsConstants.ADD_SPONSOR_ICON }}
            <i class="fas fa-times" data-qe-id="sponsor_close_btn" @click.prevent="cancel()"></i>
        </v-card-title>
        <v-card-text class="inner-scrollbar">
            <v-layout
                row
                wrap
                class="add-sponsor__row">
                <v-flex xs12 sm3>
                    <label>
                        {{ sponsorsConstants.SPONSOR_LOGO }}
                    </label>
                </v-flex>
                <v-flex xs12 sm9>
                    <file-upload
                        class="card__file-upload"
                        extensions="gif,jpg,jpeg,png,webp"
                        accept="image/png, image/gif, image/jpeg"
                        color="info"
                        data-qe-id="sponsor_file-uploader"
                        v-model="files"
                        @input-filter="inputFilterForImageFile"
                        ref="upload">
                        <v-icon
                            v-if="files.length === 0"
                            color="ypo_blue"
                            medium>photo</v-icon>
                    </file-upload>

                    <span class="add-sponsor__img" sm9 v-if="files.length > 0">
                        <v-img
                            contain
                            :src="files[0].url"
                            :height="LOGO_UNIT_PX"
                            :width="logoWidth * LOGO_UNIT_PX"
                            class="thumbnail"
                            @load="setLogoWidth"
                            ref="thumbnail"
                            id="setLogoWidth_unittests">
                        </v-img>
                        <v-icon
                            class="closeBtn"
                            data-qe-id="sponsor_remove_file"
                            @click.prevent="$refs.upload.clear">close</v-icon>
                    </span>
                </v-flex>
            </v-layout>
            <v-layout
                row
                wrap
                class="add-sponsor__row">
                <v-flex xs12 sm3>
                    <label> {{ sponsorsConstants.LINK_LOGO }} </label></v-flex>
                <v-flex xs12 sm9>
                    <v-text-field
                        single-line
                        outline
                        v-model="sponsorItem.url"
                        data-qe-id="sponsor_url_input"
                        class="card-action__text"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-card-actions>
            <v-flex text-xs-right class="pa-3">
                <v-btn
                    class="primary_btn transparent"
                    data-qe-id="sponsor_cancel_btn"
                    @click="cancel()"
                    id="cancel_unittest">{{
                    sponsorsConstants.CANCEL
                }}</v-btn>
                <v-btn
                    class="primary_btn"
                    :disabled="!formValid"
                    data-qe-id="sponsor_save_btn"
                    @click="save()"
                    id="save_unittest">{{
                    sponsorsConstants.ADD
                }}</v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { communityCommonConstant } from '@/components/ChapterPage/communityCommon.constant';
    import sponsorsConstants from './sponsors.constant';
    import { getUploadedFileBase64, inputFilterForImageFile } from '@/common/utils/fileUploader';
    import FileUpload from 'vue-upload-component';
    import { getRandomId, jsonClone } from '@/common/utils/utils';

    function newSponsor() {
        return {
            id: getRandomId(),
            logo: {},
        };
    }

    export default {
        name: 'AddSponsorDialogContent',
        components: { FileUpload },
        data: () => ({
            LOGO_UNIT_PX: 125,
            communityCommonConstant,
            sponsorsConstants,
            sponsorItem: { logo: {} },
            files: [],
            logoWidth: null,
        }),
        props: {
            item: {
                type: Object,
            },
            cancelCallBack: {
                type: Function,
                required: true,
            },
            saveCallBack: {
                type: Function,
                required: true,
            },
            currentEditingSponsorIndex: {
                type: Number,
                default: null,
            },
            showTitle: {
                type: Boolean,
                default: true,
            },
        },
        created() {
                if (this.item && this.item.id) {
                    this.sponsorItem = jsonClone(this.item);
                    this.files = [{
                        url: this.sponsorItem.logo.url,
                    }];
                } else {
                    this.sponsorItem = newSponsor();
                }
        },
        methods: {
            cancel() {
                this.cancelCallBack();
            },
            save() {
                const { file, url: logoUrl } = this.files.length ? this.files[0] : {};
                const saved = {
                    ...this.sponsorItem,
                    logo: {
                        ...this.sponsorItem.logo,
                        url: logoUrl,
                    },
                    h: 1,
                    w: this.logoWidth,
                };
                
                const uploadHandled = !file ?
                    Promise.resolve() :
                    getUploadedFileBase64(file).then((customJsonFile) => {
                        if (customJsonFile) {
                            saved.logo.data = customJsonFile.base64StringFile;
                            saved.logo.contentType = customJsonFile.fileType;
                        }
                    });

                return uploadHandled.then(() => {
                    this.saveCallBack(saved, this.currentEditingSponsorIndex);
                });
            },
            setLogoWidth() {
                const { thumbnail } = this.$refs;
                if (!thumbnail) return null;
                let w = Math.round(thumbnail.image.width / thumbnail.image.height);
                if (w > 2) w = 2;
                this.logoWidth = w;
            },
            inputFilterForImageFile,
        },
        computed: {
            formValid() {
                const reg = new RegExp(/(\S+\.[^/\s]+(\/\S+|\/|))/g);
                return this.files.length &&
                    this.sponsorItem &&
                    this.sponsorItem.url &&
                    this.sponsorItem.url.match(reg);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/common/styles/_colors.scss';
    @import '@/common/styles/_responsive.scss';

    .add-sponsor {
        &__row {
            position: relative;
            align-items: center;
            margin-bottom: 15px;

            label {
                font-size: 16px;
                color: $ypo-blue;
            }

        }

        &__img {
            display: inline-block;
            position: relative;
            padding-right: 30px;

            .closeBtn {
                position: absolute;
                top: 0;
                right: 0;
                font-weight: 600;
            }
        }

        @include breakpoint(xs) {
            &__row {
                label {
                    display: block;
                    margin-bottom: 10px;
                }
            }
        }
    }
</style>
